export const fetchFilterData = async (fileName) => {
  const response = await fetch(`/data/${fileName}.json`);
  if (!response.ok) throw new Error(`Failed to fetch ${fileName}.json`);
  return response.json();
};

export const postSearchQuery = async (queryData) => {
  const response = await fetch('/query', {         
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(queryData),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || 'Search failed');
  }
  return response.json();
};